import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    AddonSetting,
} from "../models";

/**
 * @class AddonSettingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<AddonSetting>}
 */
export class AddonSettingPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/addon-settings(/:id)';
    }

    /**
     * @returns {AddonSetting}
     * @protected
     */
    newModel(attributes, ...params) {

        return new AddonSetting(attributes);
    }


    /**
     * @param {Object=} params
     * @returns {Promise.<AddonSetting>}
     */
    get(params = {}) {

        const url = this.url({});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {AddonSetting} addonSetting
     * @returns {Promise.<AddonSetting>}
     */
    update(addonSetting) {

        const url = this.url({
            id: addonSetting.id
        });
       
        return this.http
            .put(url, addonSetting.toObjectExcept('addonSetting'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} addonId
     * @param {Object} params
     */
    show(addonId, params = {}) {

        const url = this.url({
            id: addonId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/addon-setting.service.js